import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
const contents = ['Cómo funciona realmente la industria de yates', 'Cómo iniciar el proceso correcto evitando gastos innecesarios', 'Certificaciones importantes como STCW y ENG1', 'Cómo hacer un CV que consiga entrevistas', 'Cómo conseguir tu primer embarque'];
export function EbookContent() {
  return <section className="py-16 bg-background" data-id="element-51">
      <div className="px-5" data-id="element-52">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-53">
          <h2 className="text-3xl font-bold text-white font-heading mb-3" data-id="element-54">
            ¿Qué vas a aprender?
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" data-id="element-55"></div>
        </motion.div>

        <div className="space-y-3" data-id="element-56">
          {contents.map((title, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} data-id="element-57">
              <Card className="bg-secondary/30 border-border/50 hover:border-primary/40 transition-colors" data-id="element-58">
                <CardContent className="p-4 flex items-center gap-4" data-id="element-59">
                  <div className="bg-primary text-primary-foreground w-10 h-10 rounded-full flex items-center justify-center font-bold text-base shrink-0 shadow-lg shadow-primary/20" data-id="element-60">
                    {index + 1}
                  </div>
                  <h3 className="text-base font-bold text-white leading-snug" data-id="element-61">
                    {title}
                  </h3>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}